import _camelCase from 'lodash/camelCase';
import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  alterationsCount: {
    overdue: null,
    completed: null,
    inProgress: null,
    countLoading: null,
  },
  overdue: null,
  completed: null,
  inProgress: null,
  archive: {
    count: null,
    items: [],
  },
  managerAlterations: {
    count: null,
    items: [],
  },
  foundAlterations: {
    count: null,
    items: [],
  },
  alterationItemDetails: {},
  selectedAssociateAlteration: {},
  storeAlterationsSaSearchTerm: '',
};

const updateAlterationsData = ({ dataType, count, items, resetPagination }, state) => {
  const storeKey = _camelCase(dataType);
  const currentItems = state[storeKey]?.items || [];

  return {
    [storeKey]: {
      count,
      items: resetPagination ? items : [...currentItems, ...items],
    },
  };
};

export const alterationsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.ALTERATIONS_COUNT_LOADING:
      return {
        ...state,
        alterationsCount: {
          countLoading: true,
        },
      };
    case actionTypes.ALTERATIONS_ITEMS_LOADING:
    case actionTypes.ALTERATIONS_SEARCH_LOADING:
    case actionTypes.ALTERATIONS_ITEM_DETAILS_LOADING:
    case actionTypes.MANAGER_ALTERATIONS_ITEMS_LOADING:
    case actionTypes.MANAGER_ALTERATIONS_ARCHIVE_ITEMS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.ALTERATIONS_COUNT_SUCCESS:
      return {
        ...state,
        alterationsCount: {
          ...payload,
          countLoading: false,
        },
      };
    case actionTypes.ALTERATIONS_COUNT_ERROR:
      return {
        ...state,
        alterationsCount: {
          countLoading: false,
          error: true,
        },
      };
    case actionTypes.ALTERATIONS_ITEMS_ERROR:
    case actionTypes.ALTERATIONS_SEARCH_ERROR:
    case actionTypes.ALTERATIONS_ITEM_DETAILS_ERROR:
    case actionTypes.MANAGER_ALTERATIONS_ITEMS_ERROR:
    case actionTypes.MANAGER_ALTERATIONS_ARCHIVE_ITEMS_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actionTypes.ALTERATIONS_ITEMS_SUCCESS:
      return {
        ...state,
        ...updateAlterationsData(payload, state),
        loading: false,
      };
    case actionTypes.ALTERATIONS_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        foundAlterations: {
          count: payload.count,
          items: [...state.foundAlterations.items, ...payload.items],
        },
      };
    case actionTypes.ALTERATIONS_ITEM_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        alterationItemDetails: payload,
      };
    case actionTypes.ALTERATIONS_SEARCH_CLEAR:
      return {
        ...state,
        loading: false,
        foundAlterations: {
          ...INITIAL_STATE.foundAlterations,
        },
      };
    case actionTypes.ALTERATIONS_ITEMS_CLEAR:
      return {
        ...state,
        overdue: null,
        completed: null,
        inProgress: null,
        archive: INITIAL_STATE.archive,
      };
    case actionTypes.ALTERATIONS_ITEM_DETAILS_CLEAR:
      return {
        ...state,
        alterationItemDetails: {},
      };
    case actionTypes.MANAGER_ALTERATIONS_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        managerAlterations: {
          count: payload.count,
          items: [...state.managerAlterations.items, ...payload.items],
        },
      };
    case actionTypes.MANAGER_ALTERATIONS_ITEMS_CLEAR:
      return {
        ...state,
        archive: { ...INITIAL_STATE.archive },
        managerAlterations: {
          ...INITIAL_STATE.managerAlterations,
        },
      };
    case actionTypes.MANAGER_ALTERATIONS_ARCHIVE_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        archive: {
          count: payload.size,
          items: [...state.archive.items, ...payload.alterations],
        },
      };
    case actionTypes.MANAGER_ALTERATIONS_ARCHIVE_ITEMS_CLEAR:
      return {
        ...state,
        archive: { ...INITIAL_STATE.archive },
      };
    case actionTypes.ALTERATIONS_SELECT_ASSOCIATE_ALTERATIONS:
      return {
        ...state,
        selectedAssociateAlteration: payload,
      };
    case actionTypes.MANAGER_ALTERATIONS_SA_SEARCH:
      return {
        ...state,
        storeAlterationsSaSearchTerm: payload,
      };
    case actionTypes.MANAGER_ALTERATIONS_SA_SEARCH_CLEAR:
      return {
        ...state,
        storeAlterationsSaSearchTerm: INITIAL_STATE.storeAlterationsSaSearchTerm,
      };
    default:
      return state;
  }
};

export default alterationsReducer;
